import TextArea from "antd/es/input/TextArea";
import React from "react";

const Bike = () => {
  return (
    <div className="w-full h-full !p-5">
      <div className="border-b-2 border-b-[var(--A-request)] !pb-5">
        <h2 className="text-[var(--A-request)] font-medium text-lg !mb-2">
          Bike types
        </h2>
        <div className="!mx-auto max-w-[800px]">
          <TextArea
            placeholder="Enter bike type"
            autoSize={{
              minRows: 1,
              maxRows: 4,
            }}
          />
         <div className="flex items-center justify-center !my-2">
         <button className="text-sm border-[1px] rounded-sm !px-5 !py-1 cursor-pointer border-[var(--A-request)] text-[var(--A-request)] !mx-2">Cancel</button>
         <button className="text-sm border-[1px] rounded-sm !px-5 !py-1 cursor-pointer border-[var(--A-request)] text-[var(--light)] bg-[var(--A-request)] !mx-2">Save</button>
         </div>
        </div>

        <div className="flex flex-wrap ">
            {[...Array(25)].map((item,index)=>{
                return <div key={index} className="w-[220px] grid grid-cols-8 items-center bg-[var(--tertiary)] !px-1 !py-2 rounded-sm !m-1 ">
                <p className="col-span-6 text-sm font-semibold">Hybrid {index+1}</p>
                <button className="text-[var(--A-request)]">
                <i className="fa-solid fa-pen"></i>
                </button>
                <button className="text-[red]">
                <i className="fa-solid fa-trash-can"></i>
                </button>
            </div>
            })}
        </div>
      </div>
    </div>
  );
};

export default Bike;
